var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.496,
    height: 26.588,
    viewBox: "0 0 19.496 26.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Notification-2",
    "data-name": "Notification",
    d: "M9.155,26.543a3.882,3.882,0,0,1-1.965-.974,2.139,2.139,0,0,1-.8-1.559A1.177,1.177,0,0,1,7.412,22.9a25.692,25.692,0,0,1,4.641,0,1.177,1.177,0,0,1,1.02,1.108,2.142,2.142,0,0,1-.8,1.56,3.9,3.9,0,0,1-1.964.973,3.963,3.963,0,0,1-.586.044A3.638,3.638,0,0,1,9.155,26.543ZM4.316,20.934A4.964,4.964,0,0,1,.991,19.056,5.287,5.287,0,0,1,0,15.894a4.97,4.97,0,0,1,.838-3.071A5.524,5.524,0,0,0,2.057,9.034V8.469A8.264,8.264,0,0,1,3.529,3.339,7.717,7.717,0,0,1,9.7,0h.1A7.715,7.715,0,0,1,16.07,3.489a8.172,8.172,0,0,1,1.371,4.98v.566a5.66,5.66,0,0,0,1.218,3.788,4.963,4.963,0,0,1,.838,3.071,5.286,5.286,0,0,1-.99,3.162,4.969,4.969,0,0,1-3.326,1.878c-1.8.177-3.605.328-5.432.328A41.314,41.314,0,0,1,4.316,20.934Z",
    transform: "translate(0)",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.48afd218d78db57537e3de7647ff36ca.svg";
export { ForwardRef as ReactComponent };